import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DialogsAvisosService } from '../dialogs-avisos/dialogs-avisos.service';

@Component({
  selector: 'app-dialogs-avisos',
  templateUrl: './dialogs-avisos.component.html',
  styleUrls: ['./dialogs-avisos.component.scss']
})
export class DialogsAvisosComponent implements OnInit {

  loading: boolean = true;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: boolean,
              @Optional() private dialogRef: MatDialogRef<DialogsAvisosComponent>,
              private dialog: MatDialog,
              private translateService: TranslateService,
              private dialogsAvisosService: DialogsAvisosService) { }

  ngOnInit() {
    this.dialogsAvisosService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Guarda los cambios producidos en los avisos
  */
  editAvisos(): void {

    let datosavisos = this.dialogsAvisosService.carpTipusAvisosTrue;
    this.loading = true;

    this.dialogsAvisosService.gestionAvisos(datosavisos).subscribe(res => {
      console.log(res);
      this.ngOnInit();
    }, error => {
      this.loading = false;
      console.log("Error: " + error);
    });
  }


  /**
  * @description
  * Deshabilita o habilita el botón editar avisos
  */
  deshabilitar(){
    let avisos = this.dialogsAvisosService.carpTipusAvisosTrue;
    let original = this.dialogsAvisosService.carpTipusAvisosTrueOrig;
    return this.dialogsAvisosService.compare(avisos, original);
  }

}
